import React ,{Component} from 'react';
import CIDLockoutPage from '../../pages/accountLinking/CIDLockOut'

class CIDLockOut extends Component{

    render(){

        return(

            <div className="Rectangle-100">

            <CIDLockoutPage/>

            </div>

            );
    }
}

export default CIDLockOut
